import { type AxiosError } from 'axios'
import { buildAxiosInstance } from '../../../../../shared/utils/apiUtils'
import { proxyNewUser, resetProxyNewUser } from '../../../../../shared/proxies/newUserProxy'

interface Args {
  firstName: string
  lastName: string
  email: string
  isAdmin: boolean
}

interface Response {
  data: any
  error: string | null
}

export async function executeAddNewUser ({ firstName, lastName, email, isAdmin }: Args): Promise<void> {
  proxyNewUser.apiCall.loading = true
  proxyNewUser.apiCall.error = null
  try {
    const response = await buildAxiosInstance().post<Response>('/api/users/create', {
      email: email.toLowerCase(),
      firstName,
      isAdmin,
      lastName
    })
    if (!response.data.error) {
      resetProxyNewUser()
      proxyNewUser.completed = true
    } else {
      proxyNewUser.apiCall.error = 'Unknown Error'
    }
  } catch (e) {
    if (e instanceof Error) {
      const bodyError = (e as AxiosError<Response>).response?.data?.error
      proxyNewUser.apiCall.error = bodyError ?? e.message
    }
  } finally {
    proxyNewUser.apiCall.loading = false
  }
}
